module.exports = __webpack_public_path__ + "static/media/panel1.479c6aeb.png";